import * as PlatformInfo from './src/PlatformInfo'
import {AudioCategory} from './src/PlatformInfo/types'
import * as Referrer from './src/Referrer'
import * as Share from './src/Share'
import * as SharedPrefs from './src/SharedPrefs'
import VisibilityView from './src/VisibilityView'

export {
  AudioCategory,
  PlatformInfo,
  Referrer,
  Share,
  SharedPrefs,
  VisibilityView,
}
